var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getSrc()
    ? _c(
        "div",
        {
          staticClass: "sc-message--text",
          style: Object.assign({}, _vm.messageColors, _vm.extendedStyle || {}),
          attrs: { id: "assetMessage" },
        },
        [
          _c("div", { staticClass: "media-content-wrapper" }, [
            _c(
              "a",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "bottom-end" },
                    expression:
                      "{ followCursor: true, placement: 'bottom-end' }",
                  },
                ],
                attrs: {
                  href: _vm.getSrc(),
                  download: "",
                  target: "_blank",
                  content: _vm.$t("message.download"),
                },
              },
              [
                _vm.getExt()
                  ? _c(
                      "div",
                      { staticClass: "fi", class: "fi-" + _vm.getExt() },
                      [
                        !_vm.isFilterAsset
                          ? _c("div", { staticClass: "fi-content" }, [
                              _vm._v(_vm._s(_vm.getExt())),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isFilterAsset
                          ? _c("div", { staticClass: "fi-content" }, [
                              _c("div", { attrs: { id: "fi-data" } }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.type")) +
                                      " : " +
                                      _vm._s(_vm.getExt())
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.sender")) +
                                      " : " +
                                      _vm._s(
                                        !!_vm.message.raw
                                          ? _vm.message.raw.user.name
                                          : ""
                                      )
                                  ),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _c("a-icon", { attrs: { type: "cloud-download" } }),
                _c("p", { staticClass: "asset-text mt-4" }, [
                  _vm._v(_vm._s(_vm.getAssetName())),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          !_vm.message.isMail && _vm.message.data.meta
            ? _c(
                "span",
                {
                  staticClass: "sc-message--meta",
                  class: _vm.message.author === "me" ? "received" : "sent",
                },
                [_vm._v(_vm._s(_vm.message.data.meta))]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }